import { RootState } from "reducers/types";

const emptyObj = {};
export const selectTemplateTranslations = (state: RootState) =>
  state.templateTranslations.data || emptyObj;
